var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-main',[_c('v-container',{attrs:{"fluid":""}},[(_vm.ready)?_c('v-card',[_c('trends-card',{key:_vm.id,attrs:{"id":_vm.id}})],1):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }